import { AllRealms, YEAR_LEVEL } from "api/types";
import {
	default as EChartsReact,
	default as ReactECharts,
} from "echarts-for-react";
import React, { Component } from "react";
interface AppProp {
	value: Array<any>;
	yearlevel: number;
	topic: boolean;
	onDownload: (urls: [string, string]) => void;
}
const displayRealm = [
	"Elixir \n Institute",
	"Pythagoras \n Peninsula",
	"Fahren\n  Heights",
	"Prehistoric\n Point",
	"Green Acres",
	"Habiterra",
	"DNAtion",
	"Cape Cosmos",
	"Edison Avenue",
	"E=MC Square",
];
const displayTopic = [
	"Medicine \n & Health",
	"Mathematics",
	"Weather",
	"Dinosaurs \n & Fossils",
	"Environment \n & Nature",
	"Animals",
	"Life \n & Evolution",
	"Space",
	"Inventions",
	"Physics",
];
export class YearLevel extends Component<AppProp, {}> {
	private echartsRef: React.RefObject<EChartsReact>;

	private onDownload: (urls: [string, string]) => void;

	constructor(props: AppProp) {
		super(props);
		this.echartsRef = React.createRef();
		this.onDownload = props.onDownload;
		this.state = { imgUrl: "" };
	}

	componentDidUpdate(
		_prevProps: Readonly<AppProp>,
		prevState: { imgUrl: string },
	): void {
		// @ts-ignore
		const base64: string = this.echartsRef.current
			.getEchartsInstance()
			.getDataURL();
		if (prevState.imgUrl !== base64) {
			this.setState({ imgUrl: base64 });
			this.onDownload([YEAR_LEVEL, base64]);
		}
	}

	getYearLevel(yaerlevel: number): Array<number> {
		return [
			yaerlevel + 1,
			yaerlevel + 1,
			yaerlevel + 1,
			yaerlevel + 1,
			yaerlevel + 1,
			yaerlevel + 1,
			yaerlevel + 1,
			yaerlevel + 1,
			yaerlevel + 1,
			yaerlevel + 1,
		];
	}

	getDataSeries(yearlevel: number, yearlevelarray: any): Array<any> {
		const yearlevelData = this.getYearLevel(yearlevel);
		const expectedData = [
			"-",
			"-",
			"-",
			"-",
			"-",
			"-",
			"-",
			"-",
			"-",
			"-",
		] as Array<any>;
		const aboveExpectedData = [
			"-",
			"-",
			"-",
			"-",
			"-",
			"-",
			"-",
			"-",
			"-",
			"-",
		] as Array<any>;
		const beblowExpectedData = [
			"-",
			"-",
			"-",
			"-",
			"-",
			"-",
			"-",
			"-",
			"-",
			"-",
		] as Array<any>;
		if (yearlevelarray) {
			const upData = [];
			const downData = [];

			let count = 0;
			for (const name of AllRealms) {
				if (name in yearlevelarray) {
					if (yearlevelarray[name] > yearlevel) {
						aboveExpectedData[count] = yearlevelarray[name] - yearlevel;
						// yearlevelData[count] = yearlevelarray[name];
						upData.push(
							this.props.topic
								? {
										// eslint-disable-next-line @typescript-eslint/restrict-plus-operands
										coord: [displayTopic[count], yearlevelarray[name] + 1.1],
								  }
								: {
										// eslint-disable-next-line @typescript-eslint/restrict-plus-operands
										coord: [displayRealm[count], yearlevelarray[name] + 1.1],
								  },
						);
					} else if (yearlevelarray[name] < yearlevel) {
						beblowExpectedData[count] = yearlevel - yearlevelarray[name];
						downData.push(
							this.props.topic
								? {
										// eslint-disable-next-line @typescript-eslint/restrict-plus-operands
										coord: [displayTopic[count], yearlevelarray[name] + 1.1],
								  }
								: {
										// eslint-disable-next-line @typescript-eslint/restrict-plus-operands
										coord: [displayRealm[count], yearlevelarray[name] + 0.9],
								  },
						);
					} else {
						expectedData[count] = 0.1;
					}
				}

				count += 1;
			}
			return [
				expectedData,
				aboveExpectedData,
				beblowExpectedData,
				upData,
				downData,
				yearlevelData,
			];
		} else {
			return [
				expectedData,
				aboveExpectedData,
				beblowExpectedData,
				[],
				[],
				yearlevelData,
			];
		}
	}

	getOption(yearlevel: number, yearlevelarray: any): Object {
		const symbols = {
			up: "path://M7.776 5.553a.5.5 0 0 1 .448 0l6 3a.5.5 0 1 1-.448.894L8 6.56 2.224 9.447a.5.5 0 1 1-.448-.894l6-3z;",
			down: "path://M1.553 6.776a.5.5 0 0 1 .67-.223L8 9.44l5.776-2.888a.5.5 0 1 1 .448.894l-6 3a.5.5 0 0 1-.448 0l-6-3a.5.5 0 0 1-.223-.67z;",
		};
		let expectedData = [
			"-",
			"-",
			"-",
			"-",
			"-",
			"-",
			"-",
			"-",
			"-",
			"-",
		] as Array<any>;
		let aboveExpectedData = [
			"-",
			"-",
			"-",
			"-",
			"-",
			"-",
			"-",
			"-",
			"-",
			"-",
		] as Array<any>;
		let beblowExpectedData = [
			"-",
			"-",
			"-",
			"-",
			"-",
			"-",
			"-",
			"-",
			"-",
			"-",
		] as Array<any>;
		let upData = [{}];
		let downData = [{}];
		let yearlevelData = [0];
		[
			expectedData,
			aboveExpectedData,
			beblowExpectedData,
			upData,
			downData,
			yearlevelData,
		] = this.getDataSeries(yearlevel, yearlevelarray);
		return {
			title: {
				text: "Student Current Attainment",
			},
			tooltip: {
				// trigger: "axis",
				trigger: "item",
				axisPointer: {
					type: "shadow",
				},
				// formatter: ( params: Array<any>, ) => {
				// 	// window.console.log(params)
				// 	return `
				// 			- Year Level - <br />
				// 			${params[1].marker}${params[1].seriesName}: ${params[1].data}<br />
				// 			${params[2].marker}${params[2].seriesName}: ${params[2].data}<br />
				// 			${params[3].marker}${params[3].seriesName}: ${params[3].data}<br />
				// 			  `;
				//   },
			},
			legend: {
				data: ["Increase", "Decrease", "Keep"],
			},
			grid: {
				left: "3%",
				right: "4%",
				bottom: "3%",
				containLabel: true,
				height: "60%",
			},
			xAxis: {
				type: "category",
				data: this.props.topic ? displayTopic : displayRealm,
			},
			yAxis: {
				type: "value",
				min: 1,
				max: 8,
				axisLabel: {
					verticalAlign: "bottom",
					padding: [0, 0, 13, 0],
					showMaxLabel: false,
				},
				splitArea: {
					show: true,
					areaStyle: {
						color: [
							"#FFFFFF",
							"#FFFFFF",
							"#FFFFFF",
							"#E6F2FF",
							"#FFFFFF",
							"#FFFFFF",
							"#FFFFFF",
						],
					},
				},
			},
			series: [
				{
					name: "Initial Year Level",
					type: "bar",
					stack: "Total",
					barWidth: "30%",
					itemStyle: {
						borderColor: "transparent",
						color: "transparent",
						barBorderRadius: 5,
					},
					emphasis: {
						itemStyle: {
							borderColor: "transparent",
							color: "transparent",
						},
					},
					data: yearlevelData,
				},
				{
					name: "Expected",
					type: "bar",
					stack: "Total",
					barWidth: "30%",
					itemStyle: {
						barBorderRadius: 5,
					},
					data: expectedData,
				},
				{
					name: "Below Expected",
					type: "bar",
					stack: "Total",
					data: beblowExpectedData,
					barWidth: "30%",
					itemStyle: {
						barBorderRadius: 5,
					},
					markPoint: {
						symbol: symbols.down,
						symbolSize: 20,
						data: downData,
					},
				},
				{
					name: "Above Expected",
					type: "bar",
					stack: "Total",
					barWidth: "30%",
					itemStyle: {
						barBorderRadius: 5,
					},
					data: aboveExpectedData,
					markPoint: {
						symbol: symbols.up,
						symbolSize: 20,
						data: upData,
					},
				},
			],
		};
	}

	render(): JSX.Element {
		return (
			<ReactECharts
				ref={this.echartsRef}
				option={this.getOption(this.props.yearlevel, this.props.value)}
			/>
		);
	}
}
